module.exports = __webpack_public_path__ + "img/photo-47.d1865da3.webp";